'use strict';

export default {
    show: !getCookie('show_tax') || (getCookie('show_tax') === 'true'),

    /**
     * Toggles the tax boolean
     */
    toggleTax() {

        // Post to endpoint to set new cookie, then put the below in the
        this.show = !this.show;
    },

    /**
     * Explicitly set the tax
     * @param {Boolean} bool
     */
    shouldShow(bool) {
        this.show = bool;

        createCookie('show_tax', bool, 525600);
    },

    /**
     * Sync up with our endpoint
     */
    sync() {
        // Axios call!
    }
}


// WEBPACK FOOTER //
// ./resources/assets/js/Services/Tax.js